import type {
	FilterStore
} from '@/types'
import { 
	defineStore
} from 'pinia'
import { 
	useStorage
} from '@vueuse/core'

export const useFilterStore = defineStore('filters', {
	// a function that returns a fresh state
	state: () => ({
        filters: useStorage('filters', {
			jobFilters: [] as string[],
			meetingFilters: [] as string[],
			plannerFilters: [] as string[],
			startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString('en-US', {month: 'numeric', day: '2-digit', year: 'numeric'}),
			endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toLocaleDateString('en-US', {month: 'numeric', day: '2-digit', year: 'numeric'}),
			sort: 'ascend'
        } as FilterStore) 
	}),
	
	// optional getters
	getters: {

	},

	// optional actions
	actions: {

	}
})